var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.5,
    height: 51.3,
    viewBox: "0 0 38.5 51.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10108",
    "data-name": "Grupo 10108",
    transform: "translate(-102.25 -273.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9172",
    "data-name": "Trazado 9172",
    d: "M128.063,277h6.562A4.388,4.388,0,0,1,139,281.375v35a4.388,4.388,0,0,1-4.375,4.375h-26.25A4.388,4.388,0,0,1,104,316.375v-35A4.388,4.388,0,0,1,108.375,277h6.562",
    transform: "translate(0 2.339)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9173",
    "data-name": "Trazado 9173",
    d: "M108,291.771l5.666,5.666L125.5,285.58",
    transform: "translate(4.75 12.528)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_7709",
    "data-name": "Rect\\xE1ngulo 7709",
    d: "M2,0h9.483a2,2,0,0,1,2,2V8.989a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    transform: "translate(115.063 275.289)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.3eba46dd.svg";
export { ForwardRef as ReactComponent };